export default "__VITE_ASSET__DJwr480c__"